import Image from 'next/image'
import React from 'react'

import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { WhatYouGetSectionData } from '../../data/whatYouGetSection'

const WhatYouGetSection = (props: { type?: string }) => {
  const { type = 'dsa' } = props
  return (
    <SectionLayout>
      <SectionHeader>
        What you will <span className="text-primary pl-2">get?</span>
      </SectionHeader>
      <SectionContent>
        {WhatYouGetSectionData[type].map((d, i) => (
          <div
            key={i}
            className="bg-[#3c3c7899] flex flex-col items-center justify-center rounded-md py-8 w-full sm:max-w-[300px] gap-2 px-8">
            <div className="">
              <Image src={d.icon} alt={'icon'} width={100} height={100} />
            </div>

            <div className="text-primary font-semibold text-2xl">{d.count}</div>

            <div className="font-semibold text-lg text-center">{d.heading}</div>
          </div>
        ))}
      </SectionContent>
    </SectionLayout>
  )
}

export default WhatYouGetSection
